import { ADMIN } from "@overbookd/team-code";
// src/access-manager.error.ts
var AccessManagerError = class extends Error {};
// src/grant-permission/grant-permission.ts
const PERMISSION_GRANTED = "permission-granted";
var TeamNotFound = class extends AccessManagerError {
	constructor(code) {
		super(`L'équipe ${code} est introuvable`);
	}
};
var GrantPermission = class {
	teams;
	events;
	constructor(teams, events) {
		this.teams = teams;
		this.events = events;
	}
	async apply({ to, permission }) {
		const team = await this.teams.find(to);
		if (!team) throw new TeamNotFound(to);
		if (team.permissions.includes(permission)) return team;
		const permissions = [...team.permissions, permission];
		const saved = await this.teams.save({
			code: team.code,
			permissions
		});
		this.events.publish({
			type: PERMISSION_GRANTED,
			data: {
				to,
				permission
			}
		});
		return saved;
	}
};
// src/revoke-permission/revoke-permission.ts
const PERMISSION_REVOKED = "permission-revoked";
var RevokePermission = class {
	teams;
	events;
	constructor(teams, events) {
		this.teams = teams;
		this.events = events;
	}
	async apply(request) {
		const { permission, from: team } = request;
		if (!await this.teams.is(team).ableTo(permission)) return;
		await this.teams.as(team).revoke(permission);
		this.events.publish({
			type: PERMISSION_REVOKED,
			data: request
		});
	}
};
// src/join-teams/join-teams.ts
const TEAMS_JOINED = "teams-joined";
var SomeTeamsNotFound = class extends AccessManagerError {
	constructor(teams) {
		super(`Certaines des équipes parmis ${teams.join(", ")} sont introuvables`);
	}
};
var AdminAssignmentError = class extends AccessManagerError {
	constructor() {
		super("Tu ne peux pas ajouter l'équipe admin depuis Overbookd");
	}
};
var JoinTeams = class {
	memberships;
	events;
	constructor(memberships, events) {
		this.memberships = memberships;
		this.events = events;
	}
	async apply({ member, teams }) {
		this.checkAdminArrival(teams);
		if (!await this.memberships.all(teams).exist()) throw new SomeTeamsNotFound(teams);
		if (await this.memberships.is(member.id).memberOf(teams)) return;
		await this.memberships.join(teams).as(member);
		this.events.publish({
			type: TEAMS_JOINED,
			data: {
				member,
				teams
			}
		});
	}
	checkAdminArrival(teams) {
		if (!teams.includes(ADMIN)) return;
		throw new AdminAssignmentError();
	}
};
// src/leave-team/leave-team.ts
var AdminUnassignmentError = class extends AccessManagerError {
	constructor() {
		super("Tu ne peux pas retirer l'équipe admin depuis Overbookd");
	}
};
const TEAM_LEFT = "team-left";
var LeaveTeam = class {
	memberships;
	events;
	constructor(memberships, events) {
		this.memberships = memberships;
		this.events = events;
	}
	async apply({ team, member }) {
		this.checkAdminLeave(team);
		if (!await this.memberships.is(member.id).memberOf(team)) return;
		this.memberships.leave(team).as(member);
		this.events.publish({
			type: TEAM_LEFT,
			data: {
				member,
				team
			}
		});
	}
	checkAdminLeave(team) {
		if (team !== ADMIN) return;
		throw new AdminUnassignmentError();
	}
};
// src/manage-teams.ts
const NON_MANAGEABLE_TEAMS = [ADMIN];
function isTeamManageable(team) {
	return !NON_MANAGEABLE_TEAMS.includes(team);
}
export { AccessManagerError, GrantPermission, JoinTeams, LeaveTeam, NON_MANAGEABLE_TEAMS, PERMISSION_GRANTED, PERMISSION_REVOKED, RevokePermission, TEAMS_JOINED, TEAM_LEFT, isTeamManageable };

//# sourceMappingURL=index.mjs.map